module.exports = __webpack_public_path__ + "static/img/GridBgTp1.dc05c1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/GridBgTp1.jpg
// module id = f+nw
// module chunks = 0